export default "__VITE_ASSET__IOTHmwnx__"